import React, { useEffect, useState } from 'react'
import { Rating } from 'react-simple-star-rating'
import { ReviewCardProps } from '@/components/molecules/ReviewCard/types'

export function ReviewsSlider({ reviews, classname }: { reviews: ReviewCardProps[]; classname: string }) {
  const [currentReviewIndex, setCurrentReviewIndex] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentReviewIndex((prevIndex) => (prevIndex + 1) % reviews.length)
    }, 9000)

    return () => clearInterval(interval) // Cleanup on unmount.
  }, [])

  const review = reviews[currentReviewIndex]
  if (!review) return null

  return (
    <div className={classname}>
      <Rating
        initialValue={review?.rating}
        iconsCount={5}
        SVGclassName="inline-block mb-4"
        readonly
        size={18}
        allowFraction
        SVGstorkeWidth={1}
        SVGstrokeColor="#FE8620"
        fillColor="#FE8620"
        emptyColor="rgba(255,255,255,0)"
        fillClassName="hidden"
      />
      <p className="text-bodyL mt-16 mb-24 text-text-brand-darker font-poppins  laptop:px-0 mx-auto font-bold ">
        &quot;{review?.content}&quot;
      </p>
      <p className="block font-sans text-bodyM font-bold text-text-dark-900 mb-8">{review?.author}</p>
      <p className="text-bodyM text-text-dark-900">{review?.position}</p>
    </div>
  )
}
